import libConstants from '../../../constants';

import { useState } from 'react';
import {getValidProp} from '../../../../../../utils/cleanValidateStringPropValue';
import CCIconInfoSolid16x16 from "../../../Icon/InfoSolid/16x16";
import CCIconSuccessSolid16x16 from "../../../Icon/SuccessSolid/16x16";
import CCIconWarningSolid16x16 from "../../../Icon/WarningSolid/16x16";
import CCIconAlertSolid16x16 from "../../../Icon/AlertSolid/16x16";
import computeClassName from "../../../../../../utils/computeClassName";
import CCAnnouncementActionControl, { propsDefaults as actionControlPropsDefaults } from '../../_ActionControl';
import CCAnnouncementToastDismissControl, {propsDefaults as dismissControlPropsDefaults } from "../_DismissControl";


const constants = Object.freeze({
  COMPONENT_NAME: 'CCAnnouncementToastColor',
  TYPE_BASIC: 'info',
  TYPE_SUCCESS: 'success',
  TYPE_WARNING: 'warning',
  TYPE_ALERT: 'alert',
  TYPES: ['info', 'success', 'warning', 'alert'],
  TYPE_DEFAULT: 'info',

  TYPE_ICON_COMPONENT: {
    'toastColorType_info': CCIconInfoSolid16x16,
    'toastColorType_success': CCIconSuccessSolid16x16,
    'toastColorType_warning': CCIconWarningSolid16x16,
    'toastColorType_alert': CCIconAlertSolid16x16
  },

  CLASSNAME_BASE: 'px-cc-4.5 py-4 min-w-cc-60.5 max-w-cc-90 text-cc-body-medium bg-cc-accent text-cc-accent-contrast items-start rounded shadow-cc-sm',
});

const propsDefaults = Object.freeze({
  type: constants.TYPE_DEFAULT,
  hasIcon: false,
  text: '',
  captionText: '',
  className: '',
});

function getComputedClassName(propsClassName) {
  return computeClassName(propsClassName, constants.CLASSNAME_BASE);
}

function getComputedTypeIconComponent(validType) {
  return constants.TYPE_ICON_COMPONENT[`toastColorType_${validType}`];
}

export default function CCAnnouncementToastColor(
  {
    type,
    hasIcon,
    text,
    captionText,
    actionLabel = actionControlPropsDefaults.label,
    actionFn = actionControlPropsDefaults.fn,
    actionFnArgs = actionControlPropsDefaults.fnArgs,
    dismissControlTitle = dismissControlPropsDefaults.title,
    dismissControlFn = dismissControlPropsDefaults.fn,
    dismissControlFnArgs = dismissControlPropsDefaults.fnArgs,
    className = propsDefaults.className
  }
  ) {
  const [isDismissed, setIsDismissed] = useState(false);
  const validType = getValidProp(type, 'type', constants.TYPE_DEFAULT, constants.TYPES, constants.COMPONENT_NAME, libConstants.LIB_DEBUG_LOGGER);
  const computedClassName = getComputedClassName(className);
  const TypeIconComponent = getComputedTypeIconComponent(validType);

  if (!isDismissed) {
    return (
      <div className={computedClassName} role="alert">
        <div className="flex flex-row items-start w-full">
          {
            !!hasIcon &&
            <TypeIconComponent className='flex-shrink-0 mr-5'/>
          }
          {
            !captionText && !actionLabel &&
            <div className="flex-grow">{text}</div>
          }
          {
            !captionText && !!actionLabel &&
            <div className="flex-grow flex items-center">
              <div className="flex-grow">{text}</div>
              <CCAnnouncementActionControl label={actionLabel} fn={actionFn} fnArgs={actionFnArgs} className="ml-2"/>
            </div>
          }
          {
            !!captionText && !actionLabel &&
            <div className="flex-grow flex flex-col">
              <div className="font-bold mb-2">{text}</div>
              <div className="flex-grow text-cc-white-85a">{captionText}</div>
            </div>
          }
          {
            !!captionText && !!actionLabel &&
            <>
              <div className="flex-grow flex flex-col">
                <div className="font-bold mb-2">{text}</div>
                <div className="flex-grow text-cc-white-85a mb-4">{captionText}</div>
              </div>
            </>
          }
          <CCAnnouncementToastDismissControl title={dismissControlTitle}
                                             fn={!!dismissControlFn?dismissControlFn:setIsDismissed}
                                             fnArgs={!!dismissControlFn?dismissControlFnArgs:!isDismissed}
                                             className="ml-5 flex-shrink-0"/>
        </div>
        {
          !!captionText && !!actionLabel &&
          <div className="-mx-cc-4.5 p-4 pb-0 border-t border-cc-white-50a text-center">
            <CCAnnouncementActionControl label={actionLabel} fn={actionFn} fnArgs={actionFnArgs} className="w-full"/>
          </div>
        }
      </div>

    );
  }
  return null;
}

